<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙连锁解决方案</div>
            <div class="banner_line"></div>
            <!-- <div class="banner_title2">打造以业务员为核心的超级业务员管理系统</div> -->
            <div class="banner_text">满足直营、加盟、联营不同业态经营需求，为连锁零售企业提供多门店管理能力，实现集中化管理、统一运营</div>
        </div>
        <img src="@/assets/Mobile/images/QcChain/banner.png" alt="">
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">传统连锁经营面临的烦恼</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcChain/programme1.png" alt="">
        </div>
      </div>
      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">全链路系统集成，数字化连锁解决方案</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcChain/programme2.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">多种经营模式，供商家灵活选择</div>
        </div>
        <div class="content">
            <img class="content_img" src="@/assets/Mobile/images/QcChain/programme3.png" alt="">
            <img class="content_img" src="@/assets/Mobile/images/QcChain/programme4.png" alt="">
            <img class="content_img" src="@/assets/Mobile/images/QcChain/programme5.png" alt="">
        </div>
      </div>
      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">多渠道会员统一，全域营销活动，让会员活起来</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcChain/programme6.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">多维度、全方位的经营数据分析，便于经营决策高效管控</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcChain/programme7.png" alt="">
        </div>
      </div>
      <div class="programme programme3">
        <div class="sk-mobile-title">
          <div class="title" style="color:#FFFFFF;">行业解决方案</div>
        </div>
        <div class="content" >
            <img style="width: 302px;" src="@/assets/Mobile/images/QcChain/programme8.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="千橙连锁" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="千橙连锁" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcChain,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .content_img{
    margin-top: 3px;
  }
  .content_btn{
    width: 100%;
    height: 35px;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .btn_box{
        height: 33px;
        width: 110px;
    }
  }
  .programme1{
    background: #FFFFFF;
  }
  .programme2{
    background: #FAFAFA;
  }
  .programme3{
    background: url('~@/assets/Mobile/images/QcChain/programme_bg.png');
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 9px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  